import isNil from 'lodash/isNil'
import toNumber from 'lodash/toNumber'
import React from 'react'
import type { InlineInputProps } from '../InlineInput';
import { InlineInput } from '../InlineInput'
import { NumberInput } from './NumberInput'
import { InlineDisplayEmptyContent } from '../InlineInput/InlineDisplayEmptyContent'

const defaultDisplayContent = (value) => {
  return !isNil(value) ? `${value}` : <InlineDisplayEmptyContent />
}

export const NumberInlineInput = ({ parentInputComponent, name, inputProps, updateParams, displayContent, ...rest }: InlineInputProps) => {
  const ParentInput = parentInputComponent || InlineInput
  updateParams =
    updateParams ??
    (({ updatedValue, _id }) => ({
      input: {
        _id,
        [name]: toNumber(updatedValue),
      },
    }))

  return (
    <ParentInput
      {...{
        ...rest,
        name,
        updateParams,
        displayContent: displayContent ?? defaultDisplayContent,
        editContent: (props) => <NumberInput {...{ ...props, ...inputProps }} />,
      }}
    />
  )
}
